// Export core functionalities
export { track, identify } from "./generic";
export type { AnalyticsProps } from "./types";
